import React from 'react';

const PageHeader = ({
  eyebrow,
  title,
  description,
  icon,
  iconTone = 'primary',
  actions,
  className = ''
}) => {
  const classes = `card shadow-sm page-header ${className}`.trim();

  return (
    <div className={classes}>
      <div className="card-body page-header__body">
        <div className="page-header__content">
          <div className={`page-header__icon page-header__icon--${iconTone}`} aria-hidden="true">
            <i className={`bi bi-${icon}`}></i>
          </div>
          <div className="page-header__copy">
            {eyebrow ? <div className="page-header__eyebrow">{eyebrow}</div> : null}
            <h1 className="page-header__title">{title}</h1>
            {description ? <p className="page-header__description">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="page-header__actions">{actions}</div> : null}
      </div>
    </div>
  );
};

export default PageHeader;